import { ReactNode } from "react";
import { SegHeaderLogo } from "../SegUI/SegHeaderLogo/SegHeaderLogo";
import segurarse from "../../Assets/img/logo_segurarse.svg";
import { EmpresaProps } from "../../Services/Providers/useConfiguracionEmpresa";

interface Props {
  origen: string;
  config: EmpresaProps;
  /** Solo Segurarse: lo que va al costado del logo (el teléfono de la compañía en el cotizador). */
  children?: ReactNode;
}

/**
 * Encabezado del cotizador según el origen: en un partner, barra del color del
 * origen con su logo y el de Segurarse en blanco; en Segurarse, barra blanca con
 * su logo. Lo comparten el cotizador de Auto y la pantalla del vendedor (US 23446).
 */
export const EncabezadoOrigen = ({ origen, config, children }: Props) => (
  <div className="sticky-top"
    style={{ background: origen !== "SEGURARSE" ? config.colors.navbar : "#ffffff" }}
  >
    <div className="container pt-3 pb-3">
      {
        config.origen !== "SEGURARSE" ?
          <div className="row">
            <div className="col-md-6 offset-md-3 text-center d-flex justify-content-center gap-3">
              {" "}
              {/* Centra el contenido en la columna */}
              <SegHeaderLogo
                img={config.images.logo}
                alt="Logo Segurarse"
                width={window.innerWidth > 768 ? "130px" : "100px"}
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <div style={{ height: "100%", width: "2px", backgroundColor: "#ffffff" }}></div>
              <SegHeaderLogo
                img={segurarse}
                alt="Logo Segurarse"
                width={window.innerWidth > 768 ? "140px" : "110px"}
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>

          </div>
          :
          <div className="row">
            <div className="col-md-6 offset-md-3 text-center">
              {" "}
              {/* Centra el contenido en la columna */}
              <SegHeaderLogo
                img={segurarse}
                alt="Logo Segurarse"
                width="160px"
              />
            </div>
            {children}
          </div>
      }
    </div>
  </div>
);
